import React from 'react';
import { WALLBOARD_WEATHER_LOCATIONS } from '../config/wallboardWeather';
import { useWeatherForecastBlocks } from './kioskWeather/useWeatherForecastBlocks';
import { WeatherForecastBlocksView } from './kioskWeather/WeatherForecastBlocksView';

const HomeWallboardPanel: React.FC = () => {
  const [nowMs, setNowMs] = React.useState(() => Date.now());

  const { blocks } = useWeatherForecastBlocks(WALLBOARD_WEATHER_LOCATIONS, { enabled: true });

  React.useEffect(() => {
    const t = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(t);
  }, []);

  const timeLabel = new Date(nowMs).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-4xl md:text-5xl font-semibold tabular-nums mb-6">{timeLabel}</div>
      <div className="rounded-2xl border border-base-content/10 bg-base-200/40 p-6 md:p-8 space-y-4">
        <h2 className="text-lg font-semibold text-base-content/80">Weather</h2>
        <WeatherForecastBlocksView variant="wallboard" blocks={blocks} nowMs={nowMs} />
      </div>
    </div>
  );
};

export default HomeWallboardPanel;
